import React from 'react';

export function VmSvgImage(props) {
  return (
    <img src={`https://cdn.venuemonk.com/images/partner-icons/${props.iconName}.svg`} className={props.targetClass ? props.targetClass : 'no-class'} alt={props.altText ? props.altText : "alt-text"} />
  );
}

export default VmSvgImage;
